import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { GAME_PAGE } from '../../HOME/const';
import { goToPage } from '../../HOME/REDUX/actions';
import { selectSize } from '../REDUX/actions';
import { windowSize, delay } from '../../HOME/utils';
import { Background } from '../COMPONENTS/Background';
import Size2Icon from '../ASSETS/size2.png';
import Size3Icon from '../ASSETS/size3.png';
import Size4Icon from '../ASSETS/size4.png';
import Size5Icon from '../ASSETS/size5.png';
import _ from 'lodash';
import * as f from '../logic';

class SizePage extends Component {
  handleSize = size => e => {
    delay(() => {
      this.props.selectSize(size);
      this.props.goToPage(GAME_PAGE);
    }, 200);
  };

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  sizeName = size => {
    switch (size) {
      case 2:
        return 'X-SMALL';
      case 3:
        return 'SMALL';
      case 4:
        return 'MEDIUM';
      case 5:
        return 'LARGE';
      default:
        break;
    }
  };

  getIcon = size => {
    switch (size) {
      case 2:
        return Size2Icon;
      case 3:
        return Size3Icon;
      case 4:
        return Size4Icon;
      case 5:
        return Size5Icon;
      default:
        break;
    }
  };

  render() {
    const { x, y } = windowSize();
    const cls = f.selectorClass(x, y);

    return (
      <div className="page-root">
        <div className={cls} style={{ backgroundImage: Background }}>
          {_.map([2, 3, 4, 5], (size, i) => {
            const flow = x < y ? 'column' : 'row';
            const label = this.sizeName(size);
            return (
              <div
                key={size}
                className="option triangula-option"
                style={{ gridAutoFlow: flow, padding: '15px' }}
                onClick={this.handleSize(size)}
              >
                <img src={this.getIcon(size)} width="60px" alt={label} />
                <div style={{ display: 'grid', fontSize: '20px', fontWeight: 'bold', margin: '5px 10px' }}>
                  {f.blurText(label, 4, null, { gridArea: '1/1' })}
                </div>
              </div>
            );
          })}
        </div>
        <BackButton />
        <HomeButton />
      </div>
    );
  }
}

function mapStateToProps({ tt, common }) {
  return { ...tt, ...common };
}

export default connect(
  mapStateToProps,
  { selectSize, goToPage }
)(SizePage);
